<template>
    <nav>
        <v-toolbar app flat class="hero-bb1" color="white">
            <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>

            <v-spacer class="hidden-md-and-up"></v-spacer>

            <v-btn v-if="$store.state.loggedIn" style="visibility: hidden" flat icon><v-icon>mdi-upload</v-icon></v-btn>

            <v-toolbar-title @click="$router.push('/')" style="position: relative" class="pointer" v-ripple>
                
                <img src="/logo.png" width="50" class="mt-2">
                <span class="beta">Beta</span>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items class="hidden-md-and-up">
                <v-badge v-if="$store.state.loggedIn" class="badge" overlap right color="red">
                    <template v-if="$store.state.unreadNotification !== 0" v-slot:badge>
                        <span>{{$store.state.unreadNotification}}</span>
                    </template>
                    <v-btn @click="alert = !alert" flat icon><v-icon>mdi-bell-ring-outline</v-icon></v-btn>
                </v-badge>
                <v-btn route to="/profile" flat v-if="$store.state.loggedIn" icon><v-icon>mdi-account-circle-outline</v-icon></v-btn>
                <v-btn flat v-else @click="$store.state.loginDialog = !$store.state.loginDialog" icon><v-icon>mdi-account-plus-outline</v-icon></v-btn>
            </v-toolbar-items>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn class="bra-0" route to="/lodges" flat>Lodges</v-btn>
                <!-- <v-btn class="bra-0" @click="$store.state.movageDialog = !$store.state.movageDialog" flat><v-icon left>mdi-chevron-down</v-icon>Property Relocation</v-btn> -->
                <v-btn @click="$store.state.howItWorks = !$store.state.howItWorks" class="bra-0" flat>Learn More</v-btn>
                <v-btn @click="$store.state.aboutDialog = !$store.state.aboutDialog" class="bra-0" flat>About Us</v-btn>

                <v-btn v-if="!$store.state.loggedIn" class="bra-0" flat @click="$store.state.loginDialog = !$store.state.loginDialog"><v-chip label class="pointer" color="primary" dark><v-icon class="mr-2">mdi-account-key-outline</v-icon> SignUp/Login</v-chip></v-btn>

                <v-menu v-else offset-y>
                    <v-badge slot="activator" class="bra-0 badge2" style="height: 100%" overlap right color="pink">
                        <template v-if="$store.state.unreadNotification !== 0" v-slot:badge>
                            <span>{{$store.state.unreadNotification}}</span>
                        </template>
                        <v-btn class="bra-0" flat depressed dark tile>
                            <v-chip label class="pointer" color="primary" dark>
                                <v-icon class="mr-2">mdi-star-box</v-icon>
                                <span>Dashboard</span>
                            </v-chip>
                        </v-btn>
                    </v-badge>
                    <v-list>
                        <v-list-tile @click="alert = !alert" class="px-2 pointer hover">
                            <v-list-tile-action style="min-width:40px">
                                <v-badge overlap right color="primary">
                                    <template v-if="$store.state.unreadNotification !== 0" v-slot:badge>
                                        <span>{{$store.state.unreadNotification}}</span>
                                    </template>
                                    <v-icon size="20">mdi-bell-ring-outline</v-icon>
                                </v-badge>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                Notification
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="$router.push('/profile')" class="px-2 pointer hover">
                            <v-list-tile-action style="min-width:40px">
                                <v-icon size="20">mdi-account-settings-outline</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                Profile
                            </v-list-tile-title>
                        </v-list-tile>
                        <!-- <v-list-tile @click="$router.push('/subscription')" class="px-2 pointer hover">
                            <v-list-tile-action style="min-width:40px">
                                <v-icon size="20">mdi-hexagon-slice-4</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                Subscription
                            </v-list-tile-title>
                        </v-list-tile> -->
                        <v-list-tile class="px-2 pointer hover" @click="signOutDialog = !signOutDialog">
                            <v-list-tile-action style="min-width:40px">
                                <v-icon size="20">mdi-logout</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>
                                Logout
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>

        <v-navigation-drawer app temporary v-model="drawer">
            <v-list v-if="$store.state.loggedIn" class="pa-1">
                <v-list-tile v-if="$store.state.userData !== null" avatar>
                    <v-list-tile-avatar tile>
                        <img :src="$store.state.userData.admin == true ? '/assets/admin.png' : '/assets/unknown.png'">
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{$store.state.userData.name}}</v-list-tile-title>
                        <span class="caption"><v-icon size="15" class="mr-2">mdi-account-settings-outline</v-icon> {{$store.state.userData.activated ? 'Premium Mode' : 'Free Mode'}}</span>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>

            <v-layout v-else class="py-3 px-2">
                <v-flex><v-btn @click="$store.state.registerDialog = !$store.state.registerDialog" block dark depressed color="primary"><v-icon class="mr-1">mdi-account-plus-outline</v-icon> Register</v-btn></v-flex>
                <v-flex><v-btn @click="$store.state.loginDialog = !$store.state.loginDialog" block dark flat color="primary"><v-icon class="mr-1">mdi-login</v-icon> Login</v-btn></v-flex>
            </v-layout>

            <v-list class="pt-0">
                <v-divider></v-divider>

                <template v-for="(item, index) in menuListMobile">
                    <v-list-tile v-if="item.link == ''" :key="index" @click="item.action">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-else :key="index" router :to="item.link">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>

        <!-- Authentication -->
        <Authentication />

        <!-- Notifications Dialog -->
        <v-dialog max-width="500" persistent :fullscreen="$vuetify.breakpoint.xsOnly" v-model="alert">
            <div class="white fill-height" style="min-height: 400px">
                <v-toolbar card color="white" class="bb-hero1">
                    <v-avatar tile size="32">
                        <img src="/assets/notification.png">
                    </v-avatar>
                    <v-toolbar-title>Notifications</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="alert = !alert">mdi-window-close</v-icon>
                </v-toolbar>
                <Alert/>
            </div>
        </v-dialog>

        <v-dialog v-model="$store.state.movageDialog" max-width="500">
            <v-card tile class="white pb-2">
                <v-toolbar color="white" card>
                    <v-icon color="primary">mdi-home-export-outline</v-icon>
                    <v-toolbar-title>Property movage Service</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="$store.state.movageDialog = !$store.state.movageDialog">mdi-close</v-icon>
                </v-toolbar>
                <v-divider></v-divider>
                <v-img class="" aspect-ratio="3" src="/img/hero-bg6.jpg">
                    <v-layout py-3 column bottom-gradient fill-height class="lightbox white--text">
                        <v-spacer></v-spacer>
                        <v-flex shrink>
                            <div class="px-3 py-3" :class="$vuetify.breakpoint.smAndDown == true ? 'body-1' : 'subheading'">
                                "We understand that moving your properties to a newly found lodge can be
                                    stressful and full of it’s fair share of unwelcome surprises. Knowing this we
                                    provide Nigerian students with a professional, customized and affordable
                                    property relocation service that fits your budget. Relax and do what you do
                                    best while we take the hassle of moving your properties to your newly found
                                    lodge."
                            </div>
                        </v-flex>
                    </v-layout>
                </v-img>
                <v-container class="pb-5 pt-3 mx-auto" style="max-width: 900px">
                    <p class="headline font-weight-medium">How we move</p>
                    <div class="subheading">
                        <ol>
                            <template v-for="(step, i) in howWeMove">
                                <li :key="i">{{step}}</li>
                            </template>
                        </ol>
                    </div>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn @click="requestMovage" block class="mt-2" color="success">Request Service <v-icon color="yellow" right>mdi-whatsapp</v-icon></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="$store.state.aboutDialog" max-width="500">
            <v-card tile class="white">
                <v-toolbar color="white" card>
                    <v-icon color="primary">mdi-account-group-outline</v-icon>
                    <v-toolbar-title>About Us</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="$store.state.aboutDialog = !$store.state.aboutDialog">mdi-close</v-icon>
                </v-toolbar>
                <v-divider></v-divider>
                <v-img class="" aspect-ratio="2" src="/img/banner.jpg"></v-img>
                <v-container class="py-3">
                    <div class="subheading">
                        Loj.com.ng is a modern student accommodation search platform that provides a
                        stress free means to search for off campus hostels. We provide Nigerian students
                        with a very detailed and rich lodge listings as well as professional and affordable
                        move and relocation service. We are committed to revolutionizing your student
                        experience. Search for off campus hostels, request for our relocation service all
                        from the comfort of your home.
                    </div>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="$store.state.howItWorks" class="bra-0" max-width="500">
            <v-card tile class="pb-2">
                <v-toolbar color="white" card>
                    <v-toolbar-title><span class="beta" style="font-size: 18px">Beta</span> Coming Soon</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="$store.state.howItWorks = !$store.state.howItWorks">mdi-close</v-icon>
                </v-toolbar>
                <v-divider></v-divider>
                <div>
                    <v-img class="mb-3" aspect-ratio="2" src="/assets/vector1.png"></v-img>
                    <p class="subheading px-3 py-3">
                        In line with our vision to provide Nigerian tertiary students access to a wonderful living experience, we are currently undergoing massive changes. These changes will be visible in the coming months.<br><br>
                        <span class="title">Until then, Stay tuned!!!</span>
                    </p>
                </div>
            </v-card>
        </v-dialog>

        <!-- Signout dialog -->
        <v-dialog max-width="400" persistent v-model="signOutDialog">
            <v-card>
                <v-card-text>
                    <v-icon size="20" class="mr-2">mdi-logout</v-icon><span class="subheading">Are you sure you want to logout?</span>
                    <br>
                    <p v-if="signout" class="text-center">
                        Logging out...
                        <v-progress-linear indeterminate color="primary" class="my-1"></v-progress-linear>
                    </p>
                    <div style="text-align: right">
                        <v-btn depressed round dark color="primary" @click="signOut">Yes</v-btn>
                        <v-btn depressed flat round @click="signOutDialog = false">No</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </nav>
</template>

<script>
import Authentication from './Authentication.vue'
import Alert from './VNotification.vue'
import HowItWorks from './HowItWorks.vue'
import { Auth } from '@/firebase/auth';
export default {
    components: { Authentication, Alert, HowItWorks },
    data() {
        return {
            drawer: false,
            signout: false,
            signOutDialog: false,
            alert: false,
            items: [
                { title: 'Home', icon: 'mdi-home-circle-outline' ,link: '/', auth: false},
                { title: 'Find Lodge', icon: 'mdi-home-group' ,link: '/lodges', auth: false},
                // { title: 'Property Movers', icon: 'mdi-home-export-outline' ,link: '', action: () => {this.$store.state.movageDialog = true}, auth: false},
                { title: 'Learn More', icon: 'mdi-hexagon-multiple-outline' ,link: '', action: () => {this.$store.state.howItWorks = !this.$store.state.howItWorks}, auth: false},
                // { title: 'Subscription', icon: 'mdi-hexagon-slice-5' ,link: '/subscription', auth: true},
                { title: 'Profile', icon: 'mdi-account-circle-outline' ,link: '/profile', auth: true},
                { title: 'Privacy/Policy', icon: 'mdi-axis-arrow-lock' ,link: '/policy', auth: false},
                { title: 'Terms and Condition', icon: 'mdi-assistant' ,link: '/terms', auth: false},
                { title: 'About', icon: 'mdi-account-group-outline' ,link: '', action: () => {this.$store.state.aboutDialog = !this.$store.state.aboutDialog}, auth: false},
                { title: 'Logout', icon: 'mdi-logout' ,link: '', action: () => {this.signOutDialog = !this.signOutDialog}, auth: true}
            ],
            steps: [
                {title: "Search our collections", img: "/assets/vector1.png", text: "Using the search bar above, search for the lodge of your choice. You can search by University, location or the name of the lodge. You can also filter the lodges you get in your result by price and other necessary feature you need in a lodge. Premium users have access to the whole directory of lodges. Be sure to favourite as many lodges that interests you. This will enable you get real time notifications on the vacancy number change, and the view count related to the lodge. Enabling you make well informed decisions before moving in."},
                {title: "Book through us", img: "/assets/vector2.png", text: "We advise you book the lodge through us as this will enable us to provide superior customer service to you. When you book through us, we assist you on an onsite visit and tour to as many as 3 of your most preferred favourite lodges. As well as a free property move service."},
                {title: "Move in", img: "/assets/vector3.png", text: "As soon as you’ve decided to move in to a particular lodge, we will send you the account details of the landlord to make you payments and make sure you’re given a receipt. We will also assist you on the day you move in to make sure you feel at home."},
            ],
            howWeMove: [
                "We call to confirm your request and to clarify any other necessary information.",
                "We confirm your request and book you an inspection for proper inventory analysis of items to be moved.",
                "After the inspection is done, we send you a quote based on the inspection that was carried out or based on the inventory that was sent in. We then negotiate with you on price and have a final agreement.",
                "We pack in a day, and move the next day, or pack and move on the same day depending on the quantity of the items.",
            ]
        }
    },
    methods: {
        signOut() {
            // Logs out current user
            this.signout = true

            Auth.signOut().then(() => {
                console.log('You logged Out!')

                this.signout = false
                this.signOutDialog = false
                this.$router.push('/')
                this.$store.dispatch('setSnackText', "Your Successfully logged out!")
            })
            .catch(err => {
                this.signout = false
                this.$store.dispatch('setSnackText', err)
            })
        },
        requestMovage() {
            var data = "Good day, I'm interest in Loj.com.ng Property Movage service! My name is  "
            var url = "https://wa.me/2349055841265"+"?text="+ data
            window.open(url, '_blank', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
        }
    },
    computed: {
        menuListMobile() {
            if (this.$store.state.loggedIn) {
                return this.items
            } else {
                return this.items.filter(item => {
                    return item.auth === false
                })
            }
        }
    }
};
</script>

<style scoped>
    .bottom-gradient {
       background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
    }
</style>
